export default __webpack_public_path__ + "static/media/arrow-right.de304a8f.svg";